import { Badge as MuiBadge } from "@mui/material";
import { type ReactNode } from "react";

export type BadgeProps = {
  badgeContent: ReactNode;
  children: ReactNode;
};

const PILL_BADGE_STYLES = {
  "& .MuiBadge-badge": {
    background: "linear-gradient(103deg, #93FFD4 0%, #0F9 100%)",
    px: "calc(var(--spacing)*2)",
    py: "calc(var(--spacing)*0.5)",
    color: "var(--color-text-interactive)",
    fontWeight: 400,
    fontSize: "var(--text-xs)",
    lineHeight: "var(--tw-leading, var(--text-xs--line-height))",
    height: "auto",
    minWidth: "auto",
    borderRadius: "9999px",
  },
} as const;

export function Badge({ badgeContent, children }: BadgeProps) {
  return (
    <MuiBadge
      badgeContent={badgeContent}
      color="default"
      variant="standard"
      sx={PILL_BADGE_STYLES}
    >
      {children}
    </MuiBadge>
  );
}
